<template>
  <modal class="v--modal__loader" :click-to-close="false" width="100%" :name="name">
    <div class="progress">
      <div class="progress__bar"></div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    name: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      show: this.loading
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/abstracts/_variables.scss";

.progress {
  height: 5px;
  position: relative;
  background: transparent;

  .progress__bar {
    height: 100%;
    overflow: hidden;
    background-color: $brand-success;
    background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent
    );
    background-size: 1rem 1rem;
    animation: progress-bar-move 1s linear infinite;
  }
}
@keyframes progress-bar-move {
  0% {
    background-position: 1rem 0;
  }
  100% {
    background-position: 0 0;
  }
}
</style>





// WEBPACK FOOTER //
// resources/assets/js/components/element/Loader.vue